/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Component, OnDestroy, OnInit } from '@angular/core';
import { PlaytestLiveService } from '../core/services/playtest-live.service';
import { PlaytestState } from '../shared';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Subject } from 'rxjs';

import { CdkScrollable } from '@angular/cdk/scrolling';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'nv-playtest-launch',
    templateUrl: './invitation-result.component.html',
    styleUrls: ['./invitation-result.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FlexModule, MatDialogActions, MatButton]
})
export class InvitationResultComponent implements OnInit, OnDestroy {
    private destroy$: Subject<boolean> = new Subject<boolean>();
    state = '';
    errorText = '';

    constructor(
        private playtestLiveService: PlaytestLiveService,
        private dialog: MatDialogRef<InvitationResultComponent>
    ) {
        this.state = 'waiting';

        this.state = this.playtestLiveService.getInvitationState();
        this.errorText = this.playtestLiveService.getInvitationErrorText();
        if (this.state === 'error' && !this.errorText) {
            this.errorText = 'There was an unknown error';
        }
        if (this.state === 'error') {
            if (this.errorText === 'already_joined') {
                this.errorText = 'This invitation to test has already been accepted.';
            } else if (this.errorText === 'identity_mismatch') {
                this.errorText =
                    'The email address on your GeForce NOW account does not match the email address that was invited.';
            } else if (this.errorText === 'invalid_invite') {
                this.errorText = 'This invitation to test is no longer valid.  It may have expired or been withdrawn.';
            }
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    onClick() {
        this.dialog.close();
        this.playtestLiveService.clearInvitation();
        const url = window.location.href.split('?')[0];
        window.location.replace(url);
        this.playtestLiveService.setCurrentPageState(PlaytestState.home);
    }

    ngOnInit(): void {}
}
